export default "__VITE_ASSET__CLXhBbzl__"